import { Navigate, Route } from "react-router-dom";
import TopPage from "./TopPage";
import LpPage from "./LpPage";
import ReservationDetail from "../components/Form/ReservationDetail";

class Page {
  readonly path: string;
  readonly element: JSX.Element;

  constructor(path: string, element: JSX.Element) {
    this.path = path;
    this.element = element;
  }

  get Route() {
    return <Route key={`r:${this.path}`} path={this.path} element={this.element} />;
  }
  get NavigateRoute() {
    return <Route key={`n:${this.path}`} path={"*"} element={<Navigate to={this.path} replace />} />;
  }
}

export default class Pages {
  static readonly AllPages = {
    top: new Page("", <TopPage />),
    lp: new Page("lp/*", <LpPage />),
    detail: new Page("detail/*", <ReservationDetail />),
  };

  static GetRoutes() {
    const pages = Object.values(Pages.AllPages).map((p, i) => p.Route);
    return [...pages, this.AllPages.top.NavigateRoute];
  }
}
